export const environment = {

    production: true,
    appVersion: 'v1',
    apiUrl: 'api',
    baseUrl: "https://app.seebaby.ai",
    baseCookieDomain: "",
    appUrl: "https://app.seebaby.ai",
    appThemeName: 'Metronic',
    appPurchaseUrl: 'https://1.envato.market/EA4JP',
    cookieDomain: "",
};
